import { useEffect, useRef } from "react";
import ViewPromotionManualDTO from "../dto/ViewOfferPromotionDTO";
import * as journifyTrackingCarEvents from "../services/trackingCarEvents";

const pick = (obj, keys, fallback = undefined) => {
  for (const k of keys) {
    if (obj && obj[k] !== undefined && obj[k] !== null) return obj[k];
  }
  return fallback;
};

const toNumber = (v, def = 0) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : def;
};

const toString = (v, def = "") => (v === undefined || v === null ? def : String(v));

export function useTrackVehicleOfferPromotion({ banner, SupportedVehicles, lang }) {
  const firedRef = useRef("");

  useEffect(() => {
    if (!banner || !Array.isArray(SupportedVehicles) || SupportedVehicles.length === 0) return;

    const key = `${lang}-${banner?.slug || ""}-${SupportedVehicles.length}`;
    if (firedRef.current === key) return;
    firedRef.current = key;

    const dto = new ViewPromotionManualDTO({
      promotion_id: lang === "ar" ? banner?.otherLink : banner?.slug,
      promotion_name: banner?.title,
      creative_name: banner?.title,
      creative_slot: "vehicle-offers",
      items: [],
    });

    SupportedVehicles.forEach((car, idx) => {
      dto.addItem({
        item_id: toString(pick(car, ["ProductNo", "productNo", "product_no", "ProductID", "ProductId"]), ""),
        item_name: toString(pick(car, ["DescriptionAr", "DescriptionEn", "ModelTypes", "Type English", "nameAr", "nameEn"]), ""),
        item_brand: toString(pick(car, ["brand", "brandEn"]), "value"),
        item_category: toString(pick(car, ["group", "groupEn"]), "value"),
        item_category2: toString(pick(car, ["Year", "year"]), "value"),
        item_category3: toString(pick(car, ["vehicleType"]), "value"),
        item_category4: toString(pick(car, ["carGroupID", "carGroupId"]), "value"),
        item_category5: toString(pick(car, ["type"]), "value"),
        item_list_id: toString(pick(car, ["item_list_id"]), "value"),
        item_list_name: toString(pick(car, ["item_list_name"]), "value"),
        location_id: toString(pick(car, ["location_id"]), "value"),
        index: idx,
        price: toNumber(pick(car, ["MinPrice", "minPrice", "RetailPrice", "DealerPrice"]), 0),
        quantity: toNumber(pick(car, ["Qty", "quantity"]), 1),
      });
    });

    if (dto.isValid()) {
      journifyTrackingCarEvents.trackViewOfferCar(dto.toJSON());
    }
  }, [banner, SupportedVehicles, lang]);
}
export function useTrackSelectVehicleOfferPromotion({ banner, SupportedVehicles, lang }) {
  const firedRef = useRef("");

  useEffect(() => {
    if (!banner || !Array.isArray(SupportedVehicles) || SupportedVehicles.length === 0) return;

    const key = `${lang}-${banner?.slug || ""}-${SupportedVehicles.length}`;
    if (firedRef.current === key) return;
    firedRef.current = key;

    const dto = new ViewPromotionManualDTO({
      promotion_id: lang === "ar" ? banner?.otherLink : banner?.slug,
      promotion_name: banner?.title,
      creative_name: banner?.title,
      creative_slot: "vehicle-offers",
      items: [],
    });

    SupportedVehicles.forEach((car, idx) => {
      dto.addItem({
        item_id: toString(pick(car, ["ProductNo", "productNo", "product_no", "ProductID", "ProductId"]), ""),
        item_name: toString(pick(car, ["DescriptionAr", "DescriptionEn", "ModelTypes", "Type English", "nameAr", "nameEn"]), ""),
        item_brand: toString(pick(car, ["brand", "brandEn"]), "value"),
        item_category: toString(pick(car, ["group", "groupEn"]), "value"),
        item_category2: toString(pick(car, ["Year", "year"]), "value"),
        item_category3: toString(pick(car, ["vehicleType"]), "value"),
        item_category4: toString(pick(car, ["carGroupID", "carGroupId"]), "value"),
        item_category5: toString(pick(car, ["type"]), "value"),
        item_list_id: toString(pick(car, ["item_list_id"]), "value"),
        item_list_name: toString(pick(car, ["item_list_name"]), "value"),
        location_id: toString(pick(car, ["location_id"]), "value"),
        index: idx,
        price: toNumber(pick(car, ["MinPrice", "minPrice", "RetailPrice", "DealerPrice"]), 0),
        quantity: toNumber(pick(car, ["Qty", "quantity"]), 1),
      });
    });

    if (dto.isValid()) {
      journifyTrackingCarEvents.trackSelectOfferCar(dto.toJSON());
    }
  }, [banner, SupportedVehicles, lang]);
}
export function useTrackMaintenanceOfferPromotion({ banner, packages, lang }) {
  const firedRef = useRef("");

  useEffect(() => {
    if (!banner || !Array.isArray(packages) || packages.length === 0) return;

    const key = `${lang}-${banner?.slug || ""}-${packages.length}`;
    if (firedRef.current === key) return;
    firedRef.current = key;

    const dto = new ViewPromotionManualDTO({
      promotion_id: lang === "ar" ? banner?.otherLink : banner?.slug,
      promotion_name: banner?.title,
      creative_name: banner?.title,
      creative_slot: "maintenance-offers",
      items: [],
    });

    packages.forEach((pkg, idx) => {
      dto.addItem({
        item_id: toString(pick(pkg, ["id", "ID", "Id"]), ""),
        item_name: toString(pick(pkg, ["title", "DescriptionAr", "DescriptionEn", "ModelTypes", "Type English", "nameAr", "nameEn"]), ""),
        item_brand: toString(pick(pkg, ["brand", "brandEn"]), "value"),
        item_category: toString(pick(pkg, ["group", "groupEn"]), "value"),
        item_category2: toString(pick(pkg, ["Year", "year"]), "value"),
        item_category3: toString(pick(pkg, ["vehicleType"]), "value"),
        item_category4: toString(pick(pkg, ["carGroupID", "carGroupId"]), "value"),
        item_category5: toString(pick(pkg, ["desc"]), "value"),
        index: idx,
        price: toNumber(pick(pkg, ["price", "MinPrice", "minPrice", "RetailPrice", "DealerPrice"]), 0),
        quantity: toNumber(pick(pkg, ["Qty", "quantity"]), 1),
      });
    });

    if (dto.isValid()) {
      journifyTrackingCarEvents.trackViewOfferCar(dto.toJSON());
    }
  }, [banner, packages, lang]);
}


export  function useTrackViewCarList({
  listId,
  listName,
  cars,
  currency = "SAR",
  creativeSlot, // اختياري لو تبي تربطه بمكان الظهور
}) {
  const firedRef = useRef("");

  useEffect(() => {
    if (!listId || !listName) return;
    if (!Array.isArray(cars) || cars.length === 0) return;

    // منع تكرار نفس التتبع (خصوصاً في React StrictMode)
    const first = cars[0];
    const key = `${listId}-${listName}-${cars.length}-${first?.slug || first?.productId || ""}`;
    if (firedRef.current === key) return;
    firedRef.current = key;

    const items = cars.map((car, idx) => ({
      // أهم شي: ID + Name
      item_id: toString(car?.productId ?? car?.slug, ""),
      item_name: toString(car?.name ?? car?.modelTypes, ""),

      affiliation: "value",
      coupon: "value",
      discount: 0,
      index: idx,

      // Brand / Categories
      item_brand: toString(car?.brand, "value"),
      item_category: toString(car?.group, "value"),       // مثل: RAIZE / Corolla / Camry
      item_category2: toString(car?.year, "value"),       // مثل: 2026
      item_category3: toString(car?.category, "value"),   // مثل: سيدان / SUV
      item_category4: toString(car?.carGroupID, "value"), // مثل: GR30
      item_category5: toString(car?.type, "value"),       // مثل: TN1386

      // الأفضل تكون نفس القائمة (بدل "value")
      item_list_id: toString(listId),
      item_list_name: toString(listName),

      // variant ممكن تستخدم modelTypes أو type
      item_variant: toString(car?.modelTypes ?? car?.type, "value"),

      location_id: toString(creativeSlot, "value"),

      price: toNumber(car?.minPrice, 0),
      quantity: 1,
    }));


    journifyTrackingCarEvents.trackViewCarList(toString(listId), toString(listName),items, currency);

  }, [listId, listName, cars, currency, creativeSlot]);
}

